<template>
  <div>
    <!-- <Header /> -->
    <Logo></Logo>
    <div>
      <!-- 两部分，1.岗位 2.副标题部分 -->
      <div class="post">
        <div class="post2">
          <!-- 岗位 -->
          <div class="title">{{ lists.title }}</div>
          <!-- 副标题 -->
          <div class="sub_title">
            <!-- 地点 -->
            <div class="sub_title1">地点：{{ lists.address }}</div>
            <!-- 人数 -->
            <!-- <div class="sub_title2">人数：{{ lists.count }}</div> -->
            <!-- 学历 -->
            <div class="sub_title3">学历：{{ lists.acd }}</div>
          </div>
        </div>
      </div>
      <!-- 三部分 1.需求部分 2.岗位职责 3.任职要求 -->
      <div>
        <div class="title2">
          需求专业
          <br />
          <div class="text2">{{ lists.profession }}</div>
        </div>
        <!-- <div class="title2">
          岗位职责
          <br />
          <div class="text2">{{ lists.duty }}</div>
        </div>
        <div class="title2">
          任职要求
          <br />
          <div class="text2">{{ lists.command }}</div>
        </div> -->
      </div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>
<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Join',
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.lists = this.$route.query.JobsList
  },
  components: {
    // Header,
    Logo,
    Tabbar,
  },
}
</script>
<style scoped>
/* 岗位部分的定位 */
.post {
  width: 43.875rem;
  height: 9.375rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
}
/* 岗位标题 */
.title {
  width: 39.875rem;
  height: 2.625rem;
  font-size: 2.125rem;
  color: #333333;
  padding-top: 2.625rem;
}
/* 次标题 */
.sub_title {
  display: flex;
  font-size: 1.375rem;
  color: #999999;
  padding-top: 0.875rem;
}
.sub_title1 {
  max-width: 16.25rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sub_title2 {
  margin-left: 1.625rem;
}
.sub_title3 {
  margin-left: 1.625rem;
}
/* 文中标题 */
.title2 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  font-size: 1.875rem;
  color: #333333;
  margin-top: 2rem;
}
.text2 {
  margin-top: 0.5rem;
  font-size: 1.5rem;
  color: #666666;
}
</style>
